import HelpHome from './Home'

const Modules = {
    HelpHome,
}

export default Modules
